export default __webpack_public_path__ + "static/media/cedula-nueva.b9da4faa.svg";